import { styled, useTheme } from '@mui/material/styles';
import Iconify from 'src/components/iconify';

/**
 * 훅: 그리드의 "사용 여부" 셀 렌더링 로직
 * @returns {function} renderUseYnCell
 */
const useRenderUseYnCell = () => {
  const theme = useTheme();

  const renderUseYnCell = (useYn: boolean) => {
    return (
      <UseYnContainer>
        {useYn ? (
          <Iconify
            icon="eva:checkmark-circle-2-fill"
            color={theme.palette.primary.main}
            width={24}
          />
        ) : (
          <Iconify icon="eva:close-circle-fill" color="red" width={24} />
        )}
      </UseYnContainer>
    );
  };

  return renderUseYnCell;
};

export default useRenderUseYnCell;

const UseYnContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
});
